import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import PropTypes from "prop-types";
import _ from "underscore";

import ActionLogger from "action-logger";
import NotifyMePDPContent from "components/source/user/notify-me/components/pdp-content";
import NotifyMeBanner from "components/source/user/notify-me/components/banner";
import { getAllNotifiedSKUs, isNotifyMeAvailable, isNotifyMeProduct } from "helpers/notify-me-helpers";
import AtomDropDownSelectOption from "components/source/atoms/atom-drop-down-select-option";
import AtomPrimaryButton from "components/source/atoms/atom-primary-button";
import ShippingAndReturns from "components/source/pdp/shipping-and-returns.jsx";
import * as BagActions from "actions/bag-actions";
import MembershipBagActions from "actions/membership-bag-actions";
import SizeHelper from "helpers/form-field-size-helper";
import CEBagActions from "actions/ce-bag-actions";
import SMBagActions from "actions/sm-bag-actions";
import { GodmotherErrorMap, analytics, checkout, ctaText } from "rtr-constants";
import { MODAL_NAMES } from "rtr-constants/modalNames";
import {
  withOnLoadFlagsAndExperiments,
  flagsAndExperimentNames,
  flagsAndExperimentsPropType,
} from "components/source/hoc/with-flags-and-experiments";
import MembershipPickWayfind from "components/source/membership/membership-pick-wayfind";
import AtomLoadingButton from "components/source/atoms/atom-loading-button";
import AtomErrorNotification from "components/source/atoms/atom-error-notification";
import AtomRetailPrice from "components/source/atoms/atom-retail-price";
import MembershipFormFieldsBillingStatus from "components/source/membership/membership-form-fields-billing-status";
import MembershipHelpers, { isActiveMembership } from "helpers/membership-helpers";
import { isPausedWithItems } from "helpers/membership-plan-helpers";
import MembershipUpgradesHelpers from "helpers/membership-upgrades-helpers";
import withMembershipStateInterface from "components/source/shared/interfaces/membership-state-interface";
import ProductCollectionHelpers from "helpers/product-collection-helpers";
import { productIsHomeGood } from "helpers/homegood-helpers";
import FitRecommendation from "components/source/membership/fit/fit-recommendation";
import { closeProductDrawer } from "actions/product-drawer-actions";
import ViewedProductsHelpers from "helpers/viewed-products-helpers";
import AddToBagRadioContainer from "components/source/pdp/add-to-bag-radio-container";
import MembershipShippingAddress from "components/source/membership/membership-shipping-address";
import { withShowTooltipOnLoad } from "components/source/shared/with-show-tooltip-on-load";
import { withRecommendations } from "components/source/shared/with-recommendations";
import { skuInfo } from "helpers/sku-helpers";
import ProductAvailability from "helpers/product-availability";
import { withFeatureFlags, featureFlagsPropType, Flags } from "components/source/hoc/with-feature-flags";
import GTMHelper from "helpers/gtm";
import { addToBagCEEvent } from "helpers/heap-ce-helpers";
import ReservationsActions from "actions/reservations-actions";
import Converge from "helpers/converge";
import { sendSailthruAddToCartEvent, configureSailthru } from "../../../helpers/third-party/sailthru-helpers";
import { priceStringIntoFloat } from "helpers/invoice-helper";
import { HEAP_ADD_TO_BAG_IDS } from "helpers/heap-helpers";
import { closeGridProductDrawer } from "../../../slices/gridProductDrawer-slice";
import reservationFormActions from "actions/reservation-form-actions";
import MembershipItemDummyATBContainer from "./membership-item-dummy-atb-container";
import { displayModal } from "actions/shared-actions";
import { notifyMeProductProptype } from "components/propTypes";
import UrgencySignalWrapper, {
  calculateEligiblityToShowUrgencySignalOnLegacyPdp,
} from "../products/urgency-signal/wrapper";

const kifObjectLoggingType = "kif";

export const RetailPriceWithTooltip = withShowTooltipOnLoad("Drawer")(AtomRetailPrice);

class MembershipFormFields extends React.Component {
  static propTypes = {
    addresses: PropTypes.array.isRequired,
    analyticsLoggingContext: PropTypes.object,
    ceBagCount: PropTypes.object, // @TODO: make this a proptype
    children: PropTypes.element,
    dispatch: PropTypes.func,
    favorites: PropTypes.array,
    featureFlags: featureFlagsPropType,
    flagsAndExperiments: flagsAndExperimentsPropType,
    fetchSkuAvailabilities: PropTypes.func.isRequired,
    gridProductDrawer: PropTypes.object,
    handleWayfindCtaClick: PropTypes.func,
    hasFutureCancelDate: PropTypes.bool.isRequired,
    isActiveMember: PropTypes.bool.isRequired,
    // This is used inside mapDispatchToProps, which eslint seems to not take into account
    // eslint-disable-next-line react/no-unused-prop-types
    isBuyNow: PropTypes.bool.isRequired,
    isFuturePausedWithoutItemsWithinThreeDays: PropTypes.bool.isRequired,
    isInPaymentRetry: PropTypes.bool,
    isInSkipMode: PropTypes.bool,
    isSMBagEnabled: PropTypes.bool,
    isUrgencySignallingEnabled: PropTypes.bool,
    notifyMeProducts: PropTypes.arrayOf(notifyMeProductProptype),
    sailthruConfig: PropTypes.object,
    loggingLocation: PropTypes.string,
    membershipBag: PropTypes.object,
    membershipState: PropTypes.object,
    onCancelFuturePausedModal: PropTypes.func.isRequired,
    onOpenAddShipmentModal: PropTypes.func.isRequired,
    onOpenPausedModal: PropTypes.func.isRequired,
    onOpenRetryModal: PropTypes.func.isRequired,
    product: PropTypes.object.isRequired,
    recommendations: PropTypes.arrayOf(PropTypes.shape),
    smBag: PropTypes.object,
    userData: PropTypes.object,
    workingFilters: PropTypes.object,
    isSelectedSizeAvailable: PropTypes.func,
  };

  static defaultProps = {
    isSelectedSizeAvailable: () => true,
  };

  state = {
    sizeSelected: SizeHelper.constants.defaultSizeSelection,
    addToBagButton: {
      isDisabled: true,
    },
    oneSizeFitsAll: SizeHelper.isOneSizeFitsAll(this.props.product),
  };

  componentDidUpdate(prevProps) {
    const isNewProduct = this.props?.product?.id !== prevProps?.product?.id;
    const hasWorkingFilters = this.props.workingFilters !== prevProps.workingFilters;

    // MH Explanation 10-11-19: when the addToBag action is successful and the bag is re-fetched we close the product drawer
    if (
      (!this.props?.membershipBag?.justSuccessfullyAddedItem && prevProps?.membershipBag?.justSuccessfullyAddedItem) ||
      prevProps?.ceBagCount?.members < this.props?.ceBagCount?.members
    ) {
      this.props.dispatch(closeProductDrawer());
      // New product drawer
      if (this.props.gridProductDrawer) {
        this.props.dispatch(closeGridProductDrawer());
      }
    }

    if (
      !_.isEqual(prevProps.workingFilters, this.props.workingFilters) &&
      (!MembershipHelpers.isActiveMembership(this.props.membershipState) || this.props.isBuyNow)
    ) {
      this.props.fetchSkuAvailabilities();
    }

    if (isNewProduct || hasWorkingFilters) {
      this.updateSizeState();
      this.clearBagErrors();

      if (this.willRenderActive()) {
        this.logFitAddToBagDisplay();
        this.logFitRecommendation();
      }
    }
    const isSizeAvailable =
      this.state.sizeSelected && this.state.sizeSelected !== "" ? this.isSelectedSizeAvailable() : true;
    this.props.isSelectedSizeAvailable(isSizeAvailable);
    configureSailthru(this.props.sailthruConfig);
  }

  componentDidMount() {
    this.updateSizeState();

    if (!MembershipHelpers.isActiveMembership(this.props.membershipState) || this.props.isBuyNow) {
      this.props.fetchSkuAvailabilities();
    }

    if (this.props.loggingLocation === "pdp") {
      this.logMembershipFormFieldsMounted();
    }

    if (this.willRenderActive()) {
      this.logFitAddToBagDisplay();
      this.logFitRecommendation();
    }
    configureSailthru(this.props.sailthruConfig);
  }

  fitBasePixel() {
    const primarySize = this.props?.userData?.userProfile?.profiles?.primarySize;
    return {
      object_type: "fit2_rec",
      membership_type: this.props.membershipState.membershipType,
      membership_id: this.props.membershipState.membershipId,
      user_id: this.props.userData?.userProfile?.id,
      styleId: this.props.product.id,
      primary_size: primarySize,
      location: this.props.loggingLocation,
    };
  }

  logFitRecommendation() {
    const { recommendations } = this.props;
    let logData;

    if (!recommendations) {
      return null;
    }

    const visibleRecs = recommendations.filter(s => s.isRecommended);

    if (visibleRecs.length < 1) {
      logData = {
        ...this.fitBasePixel(),
        action: "display_no_rec",
        case: "No Data",
      };
    } else {
      const loggableRecs = visibleRecs.map(s => s.size);
      const recommended_sizes_obj = {};
      loggableRecs.forEach((size, index) => {
        recommended_sizes_obj[`recommended_sizes[${index}]`] = size;
      });

      logData = {
        ...this.fitBasePixel(),
        action: "display_rec",
        ...recommended_sizes_obj,
        is_recommended_size_available: this.recommendedSizeAvail(),
        case: "Min 1 - Max 2 Sizes with Data",
      };
    }

    this.logAction(logData);
  }

  isMembershipSwapFlow() {
    const { membershipState } = this.props;
    return MembershipHelpers.canInitiateSwapFlow(membershipState) || MembershipHelpers.inSwapFlow(membershipState);
  }

  clearBagErrors() {
    this.props.dispatch(MembershipBagActions.clearBagErrors());
    this.setState({ addPurchaseToBagError: null });
  }

  handleAddToBagSuccess = () => {
    const { dispatch } = this.props;

    this.clearBagErrors();

    dispatch(BagActions.toggleBag(true));
    dispatch(BagActions.switchBagTab(BagActions.bagTabs.CLASSIC_TAB));
    dispatch(CEBagActions.get());
    dispatch(MembershipBagActions.addToCartSuccess());
    // New product drawer
    if (this.props.gridProductDrawer) {
      dispatch(closeGridProductDrawer());
    }
  };

  handleAddToBagError = response => {
    const { dispatch } = this.props;
    const sku = this.getSelectedSku();
    const { responseJSON: errorResponse } = response || {};
    const { errors: [firstError = {}] = [] } = errorResponse || {};

    let addPurchaseToBagError;

    if (firstError?.code === "UNAVAILABLE") {
      // if the item is unavailable, refresh the item availability so the PDP UI can show
      // that it's unavailable.
      dispatch(ReservationsActions.updateReservation({ primarySku: sku }));

      addPurchaseToBagError = GodmotherErrorMap.UNAVAILABLE;
    } else {
      addPurchaseToBagError =
        GodmotherErrorMap[firstError.code] ||
        GodmotherErrorMap[response?.responseText] ||
        GodmotherErrorMap.defaultAddItemToOrder;
    }

    this.setState({ addPurchaseToBagError });
  };

  handleAddToMembershipBagSuccess = () => {
    const { ceBagCount, dispatch } = this.props;

    if ((ceBagCount?.members ?? 0) < this.numOpenPickSlots()) {
      dispatch(CEBagActions.get());
    }
  };

  addPurchaseToBag = () => {
    const { userData, product, isUrgencySignallingEnabled } = this.props;
    this.clearBagErrors();

    const defaultAddress = this.props.addresses.filter(address => address.default === true)[0];

    const sku = this.getSelectedSku();
    const loggingData = this.logAddToBagData({ object_type: kifObjectLoggingType });

    this.props.dispatch(
      CEBagActions.add(
        {
          sku: sku,
          type: checkout.orderItemTypes.KIF_FROM_RACK, // "electiveSale"
          zipCode: defaultAddress.postalCode,
        },
        false,
        loggingData,
        this.handleAddToBagSuccess,
        this.handleAddToBagError
      )
    );

    this.sendAddToBagTrackingEvent(sku, checkout.orderItemTypes.KIF_FROM_RACK);
    Converge.trackAddedToCart(this.props.product, "kiffr");
    const { isEligible, availabilityOfSelectedSku } = calculateEligiblityToShowUrgencySignalOnLegacyPdp(
      product?.skus,
      sku,
      isUrgencySignallingEnabled,
      userData,
      false,
      true
    );

    addToBagCEEvent(analytics.RETAIL, analytics.KIFFR, {
      type: `${analytics.OBJECT_TYPE.SUB_KIFFR}_${this.props.loggingLocation}`,
      is_notify_me: isNotifyMeProduct(this.props.product?.id, this.props.notifyMeProducts),
      urgencySignalShown: isEligible,
      urgencySignalItemsLeft: availabilityOfSelectedSku,
      urgencySignalExperimentStatus: isUrgencySignallingEnabled,
      selectedSize: sku,
    });
  };

  sendAddToBagTrackingEvent(selectedSku, orderType) {
    const { product, userData = {} } = this.props;
    GTMHelper.addToCartEvent(product, selectedSku, false, userData?.userProfile?.id, userData?.userProfile?.email);
    sendSailthruAddToCartEvent(product, userData.userProfile?.email, null, orderType);
  }

  getSelectedSku() {
    const { product = {}, membershipState = {} } = this.props;
    if (this.state.selectedSize && ProductAvailability.hasSkuCount(this.state.selectedSize, product, membershipState)) {
      const {
        product: { skus = [] },
      } = this.props;
      const skuSelected = skus.find(({ size }) => size === this.state.selectedSize);

      this.skuIdSelected = skuSelected?.id; // saving selected sku
    }

    return this.skuIdSelected;
  }

  addRentalToBag = () => {
    const { product, notifyMeProducts, favorites = [], userData, isUrgencySignallingEnabled } = this.props;
    this.clearBagErrors();

    const sku = this.getSelectedSku();

    this.sendAddToBagTrackingEvent(sku, analytics.SWAP_ORDER);
    Converge.trackAddedToCart(this.props.product, "swap");

    const { isEligible, availabilityOfSelectedSku } = calculateEligiblityToShowUrgencySignalOnLegacyPdp(
      product?.skus,
      sku,
      isUrgencySignallingEnabled,
      userData,
      false,
      false
    );

    addToBagCEEvent(analytics.RENT, analytics.SUBSCRIPTION, {
      type: `${analytics.OBJECT_TYPE.SUB_RENTAL}_${this.props.loggingLocation}`,
      style_name: product?.id,
      is_hearted: favorites.includes(product?.id),
      is_notify_me: isNotifyMeProduct(product?.id, notifyMeProducts),
      urgencySignalShown: isEligible,
      urgencySignalItemsLeft: availabilityOfSelectedSku,
      urgencySignalExperimentStatus: isUrgencySignallingEnabled,
      selectedSize: sku,
    });

    return this.addToBag(sku);
  };

  // can be removed with removal of 'keep-it-forever-atb'
  addToBag(sku) {
    const { ceBagCount, recommendations, product, userData, isSMBagEnabled } = this.props;

    const fitRates = product?.fitRates || [];
    const additionalLogData = this.logAddToBagData();

    let addToBag;
    if (isSMBagEnabled) {
      const defaultAddress = this.props.addresses.find(address => address.default === true);

      const handleAddToMembershipBagSuccess = () => {
        ActionLogger.logAction({
          ...additionalLogData,
          style_name: skuInfo(sku).id,
          action: ActionLogger.RezoAddToCart,
        });
      };

      const handleAddToMembershipBagFailure = error => {
        ActionLogger.logAction({
          ...additionalLogData,
          action: ActionLogger.RezoAddToCartFailure,
          error,
        });
      };

      addToBag = SMBagActions.addBagItemPromise(
        {
          sku: sku,
          type: "members",
          zipCode: defaultAddress.postalCode,
        },
        handleAddToMembershipBagSuccess,
        handleAddToMembershipBagFailure,
        { productId: product?.id, retailPriceInteger: product?.retailPriceInteger }
      );
    } else {
      const defaultAddress = this.props.addresses.find(address => address.default === true);
      addToBag = CEBagActions.add(
        {
          sku: sku,
          type: "members",
          zipCode: defaultAddress.postalCode,
        },
        (ceBagCount?.members ?? 0) + 1 >= this.numOpenPickSlots(),
        additionalLogData,
        this.handleAddToMembershipBagSuccess,
        this.handleAddToBagError
      );
    }

    this.props.dispatch(addToBag);

    // remove item added to bag from saved "viewed products" list
    const styleName = this.props?.product?.id;
    ViewedProductsHelpers.removeViewedProductFromList(styleName, userData);

    if (recommendations && this.willRenderActive()) {
      const sizeSelected = sku.split("_")[1];
      const visibleRecs = recommendations.filter(s => s.isRecommended);
      const loggableRecs = visibleRecs.map(s => s.size);
      const skuFitProbablity = fitRates.find(rate => rate.size === sizeSelected)?.fitRate;
      const recommended_sizes_obj = {};
      loggableRecs.forEach((size, index) => {
        recommended_sizes_obj[`recommended_sizes[${index}]`] = size;
      });

      this.logAction({
        ...this.fitBasePixel(),
        action: "add_size_to_bag",
        ...recommended_sizes_obj,
        is_recommended_size_available: this.recommendedSizeAvail(),
        case: "Min 1 - Max 2 Sizes with Data",
        location: "selector",
        size_picked: sizeSelected,
        sku_fit_probability: skuFitProbablity,
      });
    }
  }

  getDefaultSizeSelection() {
    const { workingFilters = {}, userData = {}, product = {}, membershipState = {} } = this.props;
    const primarySize = userData.userProfile?.profiles?.primarySize;

    return ProductAvailability.getDefaultSizeSelection(
      product,
      userData,
      membershipState,
      workingFilters,
      this.isNotifyMeAvailable(primarySize) && workingFilters.canonicalSizes?.length > 0 // will determine whether or not we want a default size selected thats available or out of stock
    );
  }

  updateSizeState() {
    const defaultSizeSelection = this.getDefaultSizeSelection();

    // Log the default size selection only when workingFilters exists.
    if (this.props.workingFilters) {
      this.logSizePreselection(defaultSizeSelection?.size);
    }

    this.setState({
      sizeSelected: defaultSizeSelection?.size,
      addToBagButton: {
        isDisabled: this.isButtonDisabled(defaultSizeSelection?.size),
      },
    });

    this.skuIdSelected = defaultSizeSelection?.sku;
  }

  buttonCopy() {
    const { membershipBag, membershipState } = this.props;
    const notInPickMode = MembershipHelpers.hasNoShipmentAction(membershipState);
    const hasUnlimitedShipments = !membershipState.monthlyShipmentLimit;
    const bagIsEmpty = MembershipHelpers.isBagEmpty(membershipBag);
    let buttonCopy =
      hasUnlimitedShipments && notInPickMode && bagIsEmpty ? ctaText.START_NEW_SHIPMENT : ctaText.ADD_TO_BAG;

    if (this.props?.membershipBag?.isAddingItem) {
      buttonCopy = ctaText.ADDING;
    }

    if (this.props?.membershipBag?.justSuccessfullyAddedItem) {
      buttonCopy = ctaText.ADDED_TO_BAG;
    }

    return buttonCopy;
  }

  numOpenPickSlots() {
    if (typeof this.props.smBag?.numOpenSlots === "number") {
      return this.props.smBag.numOpenSlots;
    }
    return MembershipHelpers.fetchNumOpenSlots(this.props.membershipState);
  }

  /**
   * Disables the CTA if the item is outside of the user's eligible inventory or
   * if the item is unavailable in the selected size.
   * @param {String} selectedSize
   * @returns {Bool}
   */
  isButtonDisabled(selectedSize) {
    const { product = {}, membershipState = {} } = this.props;

    if (!this.memberCanInitiateSwap()) {
      return true;
    }

    const isProductEligibleForUser = ProductAvailability.checkProductIsEligibleForUser(product, membershipState);

    // if sizeless accessory than just enable button, it won't be in the grid call if doesn't have a count.
    if (!SizeHelper.hasProductSizes(product)) {
      return false;
    } else if (!isProductEligibleForUser) {
      // Early return true if the item is out of the user's eligible inventory
      return true;
    } else if (selectedSize && ProductAvailability.hasSkuCount(selectedSize, product, membershipState)) {
      return false;
    }

    return true;
  }

  getSkuAvailabilities() {
    const { product = {}, membershipState = {}, product: { sizeScale: { sizeNames } = {} } = {} } = this.props;

    //Subscription prospects are treated as eligible for unlimited (Full Closet access) products
    const isProspect = !isActiveMembership(membershipState);
    const isEligible = ProductAvailability.checkProductIsEligibleForUser(product, membershipState) || isProspect;
    const sizeMap = ProductAvailability.sizeToAvailabilityCountMap(product, membershipState);

    return Object.keys(sizeMap)
      .filter(k => k in sizeNames)
      .reduce((memo, key) => {
        memo[key] = sizeNames[key];

        if (!sizeMap[key].count || !isEligible) {
          memo[key] += " - Unavailable"; // if the count is 0 or there is no count
        }

        return memo;
      }, {});
  }

  noSkusAvailable() {
    const { product = {}, membershipState = {} } = this.props;
    const sizeCounts = ProductAvailability.sizeToAvailabilityCountMap(product, membershipState);
    return Object.values(sizeCounts).every(size => !size.count);
  }

  isLogLocationDrawer() {
    return this.props.loggingLocation === "drawer";
  }

  isPDPItemAvailable() {
    const { product, featureFlags } = this.props;
    // We only need to check these fields on the actual PDP page itself,
    // unavailable items that have segmentedForDepot = false or lockedByLoyaltyAccess = true
    // are filtered out of carousels and grids by the backend
    if (!featureFlags?.[Flags.EARLY_ACCESS_PDP] || this.isLogLocationDrawer()) {
      return true;
    }
    return product.segmentedForDepot && !product.lockedByLoyaltyAccess;
  }

  logAction(object) {
    ActionLogger.logAction(object);
  }

  logMembershipFormFieldsMounted() {
    this.logAction({
      object_type: "membership_pdp",
      action: "display_membership_pdp_form",
      style_name: this.props.product.id,
    });
  }

  logFitAddToBagDisplay() {
    this.logAction({ ...this.fitBasePixel(), action: "display_add_to_bag" });
  }

  getMembershipAddToCartObjectType(userData) {
    /* NW [EXPLANATION] 5/10/19: when user is adding to bag from PDP (not grid/HP drawer) Add to Cart pixel should send membership PDP object_type
     * otherwise, the object_type will be passed down in this.props.analyticsLoggingContext */
    if (!this.isLogLocationDrawer()) {
      if (MembershipHelpers.isRtrUpdateMember(userData)) {
        // NW [EXPLANATION] 5/10/19: analytics uses `membership` object_type to find Update Add to Cart actions
        return analytics.OBJECT_TYPE.MEMBERSHIP;
      }
    }
    return null;
  }

  logAddToBagData(additionalLoggingData = {}) {
    const { analyticsLoggingContext = {}, membershipState, product, userData } = this.props;
    const { membershipType: membership_type, membershipId: membership_id } = membershipState;

    const sku = this.getSelectedSku();
    const { id: styleName, size: pSize } = skuInfo(sku);

    // NW [EXPLANATION] 4/23/19: in the case that the analyticsLoggingContext has not been provided, membership will have to be determined here
    const membership = MembershipHelpers.getMembershipTypeAnalytics(userData.memberships, membershipState);
    const logData = {
      pSize,
      styleName,
      membership,
      membership_type,
      membership_id,
      ...analyticsLoggingContext,
    };

    /* NW [EXPLANATION] 5/14/19: when user is adding to bag from PDP (not grid/HP drawer) this component will specify the membership PDP object_type
     * otherwise, the object_type will be passed down from this.props.analyticsLoggingContext */
    const logObjectType = this.getMembershipAddToCartObjectType(userData);
    if (logObjectType) {
      logData.object_type = logObjectType;
    }

    return {
      ...logData,
      ...additionalLoggingData,
      productId: product?.id,
      retailPriceInteger: product?.retailPriceInteger,
    };
  }

  logSizePreselection(preselectedSize) {
    let logObjectType = "membership_pdp";
    let logActionType = "pdp_size_preselection";

    if (this.isLogLocationDrawer()) {
      logObjectType = "membership_drawer";
      logActionType = "drawer_size_preselection";
    }

    this.logAction({
      object_type: logObjectType,
      action: logActionType,
      style_name: this.props.product.id,
      size: preselectedSize,
    });
  }

  logUpgradeAddToShipment() {
    if (MembershipHelpers.isBagFull(this.props.membershipState, this.props.membershipBag)) {
      const membership = MembershipHelpers.getMembershipTypeAnalytics(
        this.props.userData.memberships,
        this.props.membershipState
      );
      const adjustedPrice = this.props.product?.price?.adjusted;
      const logData = {
        object_type: analytics.OBJECT_TYPE.ADD_ON,
        action: analytics.ADD_ON_ACTIONS.ADD_SLOTS,
        membership,
        source: "pdp",
        rental_price: adjustedPrice,
      };
      this.logAction(logData);
    }
  }

  logChangeSizeSelected(selectedSize) {
    const { recommendations } = this.props;

    let logObjectType = "membership_pdp";
    let logActionType = "pdp_size_selection";

    if (this.isLogLocationDrawer()) {
      logObjectType = "membership_drawer";
      logActionType = "drawer_size_selection";
    }

    this.logAction({
      object_type: logObjectType,
      action: logActionType,
      style_name: this.props.product.id,
      size: selectedSize,
    });

    if (recommendations && this.willRenderActive()) {
      const visibleRecs = recommendations.filter(s => s.isRecommended);
      const loggableRecs = visibleRecs.map(s => s.size);
      const recommended_sizes_obj = {};
      loggableRecs.forEach((size, index) => {
        recommended_sizes_obj[`recommended_sizes[${index}]`] = size;
      });

      this.logAction({
        ...this.fitBasePixel(),
        action: "display_rec_selector",
        ...recommended_sizes_obj,
        is_recommended_size_available: this.recommendedSizeAvail(),
        case: "Min 1 - Max 2 Sizes with Data",
        location: "selector",
      });
    }
  }

  recommendedSizeAvail = () => {
    const { recommendations } = this.props;
    if (!recommendations) {
      return false;
    }

    const { product = {}, membershipState = {} } = this.props;

    const visibleRecs = recommendations.filter(s => s.isRecommended);
    const loggableRecs = visibleRecs.map(s => s.size);
    return loggableRecs.filter(rec => ProductAvailability.hasSkuCount(rec, product, membershipState)).length > 0;
  };

  handleAddToMembershipBag = e => {
    e.preventDefault();

    if (this.skuIdSelected) {
      this.addToBag(this.skuIdSelected);
      this.logUpgradeAddToShipment();
    }
  };

  handleSizeSelectorChange = selectedSize => {
    const { product = {}, membershipState = {} } = this.props;
    // saving sku for later use.
    if (selectedSize && ProductAvailability.hasSkuCount(selectedSize, product, membershipState)) {
      const {
        product: { skus },
      } = this.props;
      const skuSelected = skus.find(sku => sku.size === selectedSize);

      this.skuIdSelected = skuSelected?.id; // saving selected sku
    }

    this.setState(
      {
        sizeSelected: selectedSize,
        addToBagButton: {
          isDisabled: this.isButtonDisabled(selectedSize),
        },
      },
      this.renderAddToBagButton
    );

    this.logChangeSizeSelected(selectedSize);

    // If errors show because various reasons, selecting a new size will clear the errors.
    this.clearBagErrors();
  };

  renderSizeSelector = () => {
    const { product = {}, membershipState = {} } = this.props;
    // For products with multiple sizes, show selector
    const allSizesUnavailable = ProductAvailability.allSizesUnavailable(product, membershipState);
    if (SizeHelper.hasProductSizes(this.props.product)) {
      return (
        <div className="product-drawer__size-selector">
          <AtomDropDownSelectOption
            onChange={this.handleSizeSelectorChange}
            dropdownValues={this.getSkuAvailabilities()}
            placeholderOption={ProductCollectionHelpers.getSizesPlaceholder(
              this.props.product,
              false,
              allSizesUnavailable
            )}
            selectorName={"product-drawer-select-size"}
            optionalClassName={"universal-small"}
            selectedOption={this.state.sizeSelected}
          />
        </div>
      );
    }

    // Otherwise, save the sku for adding to bag.
    this.skuIdSelected = this.props?.product?.skus?.[0]?.id;
    return;
  };

  isSelectedSizeAvailable = () =>
    ProductAvailability.hasSkuCount(this.state.sizeSelected, this.props.product, this.props.membershipState);

  isRentingDefaultChecked = () => this.isRentingEnabled();

  isPurchaseDefaultChecked = () => !this.isRentingEnabled() && this.isPurchaseEnabled();

  isNotifyMeAvailable = selectedSize =>
    Boolean(isNotifyMeAvailable(selectedSize, this.props.product, this.props.membershipState));

  isSizeAlreadyNotified = () =>
    Boolean(
      Array.isArray(getAllNotifiedSKUs(this.props.product.id, this.props.notifyMeProducts)) &&
        getAllNotifiedSKUs(this.props.product.id, this.props.notifyMeProducts).length
    );

  // can swap && items available
  isRentingEnabled = () => {
    const { membershipState, product } = this.props;
    const memberCanPick = MembershipHelpers.isEligibleToPick(membershipState);
    const sizesAvailable = this.isSelectedSizeAvailable() || !SizeHelper.hasProductSizes(product);
    const itemAvailable = this.isPDPItemAvailable();

    if (!ProductAvailability.checkProductIsEligibleForUser(product, membershipState)) {
      return false;
    }

    if (
      this.state.oneSizeFitsAll &&
      memberCanPick &&
      itemAvailable &&
      this.memberCanInitiateSwap() &&
      this.isOneSizeProductOutOfStock()
    ) {
      return false;
    }

    if (memberCanPick && itemAvailable && sizesAvailable && this.memberCanInitiateSwap()) {
      return true;
    }

    return false;
  };

  // item available && not home goods
  isPurchaseEnabled = () => {
    const { membershipState, product } = this.props;
    const sizesAvailable =
      ProductAvailability.hasSkuCount(this.state.sizeSelected, product, membershipState) ||
      !SizeHelper.hasProductSizes(product);
    const itemAvailable = this.isPDPItemAvailable();

    if (!ProductAvailability.checkProductIsEligibleForUser(product, membershipState)) {
      return false;
    }

    if (
      itemAvailable &&
      !productIsHomeGood(product) &&
      this.state.oneSizeFitsAll &&
      this.isOneSizeProductOutOfStock()
    ) {
      return false;
    }

    if (sizesAvailable && itemAvailable && !productIsHomeGood(product)) {
      return true;
    }
    return false;
  };

  memberCanInitiateSwap() {
    const { membershipState } = this.props;

    // Disable the button when a cross ship eligible user is not in swap flow and does not have open slots
    return !membershipState.crossShipEligible || this.isMembershipSwapFlow() || this.numOpenPickSlots();
  }

  renderPurchasePrice() {
    // Tooltip will only be shown when the item is a home good
    const { product: { designer: { id: designerId } = {}, purchasePrice, retailPrice, retailPriceFormatted } = {} } =
      this.props;

    if (!retailPrice) return;

    return (
      <RetailPriceWithTooltip
        designerId={designerId}
        className="price"
        product={this.props.product}
        purchasePrice={purchasePrice}
        retailPrice={retailPrice}
        retailPriceFormatted={retailPriceFormatted}
        showPurchasePrice={true}
        showPurchasePriceDiscount={true}
        showPurchasePriceTooltip={this.isHomeGood()}
        suppressRetailValueCopy={true}
        hideRetailValue={true}
        tooltipAlign="right"
      />
    );
  }

  isHomeGood() {
    const { product } = this.props;

    return productIsHomeGood(product);
  }

  renderRentalPrice() {
    const { ceBagCount, membershipState } = this.props;
    let priceString;

    const { shipmentsCount, baseSlotUpgradePrice } = membershipState;
    const hasAtLeastOneReturnPromise = MembershipHelpers.hasAtLeastOneReturnPromise(membershipState);
    const hasAllItemsAtHome = MembershipHelpers.hasAllItemsAtHome(membershipState);
    const isSubscriptionLens = MembershipHelpers.isSubscriptionLens(this.props.userData);

    // RF [EXPLANATION] 12/16/20: Override price as $0 for a fixed ship user with
    // remaining shipments as long as they haven't marked anything as return promise
    // (even if number of at-home + newly-added is over the spot count)
    if (shipmentsCount > 0 && hasAllItemsAtHome && !hasAtLeastOneReturnPromise) {
      priceString = "$0 to rent";
    } else if (
      // we don't want to show an adjusted price for the product if the user's membership bag is not full
      isSubscriptionLens &&
      !MembershipHelpers.isBagFullCe(membershipState, ceBagCount)
    ) {
      priceString = "$0 to rent";
    } else if (isSubscriptionLens && MembershipHelpers.hasMembershipDiscount(this.props.product.price)) {
      let suffix;

      // use membership state upgrade price so we don't have to refresh carousels when users add to bag
      if (this.getUpgradeAnnotationAppendString()) {
        priceString = "$" + priceStringIntoFloat(baseSlotUpgradePrice);
        suffix = " extra spot";
      } else {
        priceString = "$" + Math.ceil(this.props.product.price.adjusted);
        suffix = " to rent";
      }
      priceString += suffix;
    } else if (this.props.product.price) {
      priceString = this.props.product.price.minimumFormatted;
    }

    return <span className="price">{priceString}</span>;
  }

  getUpgradeAnnotationAppendString() {
    const { ceBagCount, featureFlags, membershipState, userData } = this.props;

    const unlimitedAlwaysOnAddOnsFF = featureFlags?.[Flags.UNLIMITED_ALWAYS_ON_ADD_ONS];

    return MembershipUpgradesHelpers.getUpgradeAnnotationAppendCE(
      membershipState,
      userData,
      ceBagCount,
      unlimitedAlwaysOnAddOnsFF
    );
  }

  renderRadioButtonProps() {
    const { product = {}, membershipState = {}, userData = {}, handleWayfindCtaClick } = this.props;

    if (this.isNotifyMeAvailable(this.state.sizeSelected)) {
      return (
        <NotifyMePDPContent
          handleWayfindCtaClick={handleWayfindCtaClick}
          membershipState={membershipState}
          product={product}
          purchasePrice={this.renderPurchasePrice()}
          rentalPrice={this.renderRentalPrice()}
          selectedSize={this.state.sizeSelected}
          userData={userData}
        />
      );
    } else if (
      SizeHelper.hasProductSizes(product) &&
      ProductAvailability.allSizesUnavailable(product, membershipState)
    ) {
      return this.renderAddToBagRadioContainer([]);
    } else {
      const radioButtons = [
        {
          disabled: !this.isRentingEnabled(),
          defaultChecked: this.isRentingDefaultChecked(),
          ctaCopy: this.renderCTACopy(),
          copy: this.renderRentalCopy(),
          price: this.renderRentalPrice(),
          action: this.addRentalToBag,
          key: "renting",
          dataHeapId: HEAP_ADD_TO_BAG_IDS.MEMBERSHIP_ITEM,
        },
        {
          disabled: !this.isPurchaseEnabled(),
          defaultChecked: this.isPurchaseDefaultChecked(),
          ctaCopy: this.renderCTACopy(),
          copy: this.renderPurchaseCopy(),
          price: this.renderPurchasePrice(),
          action: this.addPurchaseToBag,
          key: "purchasing",
          dataHeapId: HEAP_ADD_TO_BAG_IDS.KIFFR,
        },
      ];
      return this.renderAddToBagRadioContainer(radioButtons);
    }
  }

  renderCTACopy() {
    const { product, membershipState } = this.props;

    // if there is no size selected and the item is not an accessory
    if (!this.state.sizeSelected && SizeHelper.hasProductSizes(product)) {
      return "select a size";
    }

    // if there is no size selected, we don't have to worry about accessories because they don't appear
    // on the grid if they're unavailable
    if (
      (!ProductAvailability.hasSkuCount(this.state.sizeSelected, product, membershipState) &&
        SizeHelper.hasProductSizes(product)) ||
      (this.state.oneSizeFitsAll && this.isOneSizeProductOutOfStock()) ||
      !ProductAvailability.checkProductIsEligibleForUser(product, membershipState)
    ) {
      return "currently unavailable";
    }
    return "add to bag";
  }

  isOneSizeProductOutOfStock() {
    return this.props.product.skus[0].unlimitedAvailabilities[0].count === 0;
  }

  renderRentalCopy() {
    const { userData, product, membershipState, handleWayfindCtaClick } = this.props;

    return (
      <>
        <MembershipShippingAddress />
        <MembershipPickWayfind
          handleWayfindCtaClick={handleWayfindCtaClick}
          membershipState={membershipState}
          product={product}
          userData={userData}
        />
      </>
    );
  }

  renderPurchaseCopy() {
    const { featureFlags, userData, product, membershipState, handleWayfindCtaClick, isBuyNow } = this.props;
    if (featureFlags?.[Flags.KEEP_IT_FOREVER_RETURNS]) {
      return (
        <div
          className={`${
            this.props.flagsAndExperiments?.[flagsAndExperimentNames.RSV_1494_ATB_TABS] && !isBuyNow ? "!-mt-8" : ""
          } returns-copy`}>
          <MembershipPickWayfind
            handleWayfindCtaClick={handleWayfindCtaClick}
            membershipState={membershipState}
            product={product}
            userData={userData}
          />
          <ShippingAndReturns product={product} hasAddress={!!membershipState?.address} />
        </div>
      );
    }
    return <p className="flex items-baseline flex-wrap p-0">All purchases are final.</p>;
  }

  renderAddToBagRadioContainer(radioButtons) {
    const { handleWayfindCtaClick, membershipState, product, userData, workingFilters } = this.props;

    return (
      <AddToBagRadioContainer
        handleWayfindCtaClick={handleWayfindCtaClick}
        membershipState={membershipState}
        product={product}
        userData={userData}
        radioButtons={radioButtons}
        disabledCTACopy={this.renderCTACopy()}
        workingFilters={workingFilters}
        className={`${this.props.flagsAndExperiments?.[flagsAndExperimentNames.RSV_1494_ATB_TABS] ? "!gap-0" : ""}`}
      />
    );
  }

  // TODO https://renttherunway.jira.com/browse/QU-11195
  renderAddToBagButton = () => {
    let button;
    if (this.props.membershipBag?.isAddingItem ?? false) {
      button = <AtomLoadingButton buttonText={this.buttonCopy()} textWidth={"90"} />;
    } else {
      button = (
        <AtomPrimaryButton
          onClick={this.handleAddToMembershipBag}
          buttonText={this.buttonCopy()}
          disabled={this.noSkusAvailable() || this.state.addToBagButton.isDisabled}
        />
      );
    }

    return <div className="product-drawer__button">{button}</div>;
  };

  willRenderActive() {
    const { isActiveMember, membershipState, hasFutureCancelDate, isFuturePausedWithoutItemsWithinThreeDays } =
      this.props;
    const eligibleBillingStatuses = MembershipHelpers.inGoodStanding(membershipState);

    return (
      isActiveMember &&
      eligibleBillingStatuses &&
      !hasFutureCancelDate &&
      !isFuturePausedWithoutItemsWithinThreeDays &&
      !isPausedWithItems(membershipState)
    );
  }

  renderAddPurchaseToBagError() {
    const { addPurchaseToBagError } = this.state;

    if (!addPurchaseToBagError) return;

    return <AtomErrorNotification errorCopy={addPurchaseToBagError} />;
  }

  renderFitRecommendation() {
    return (
      <FitRecommendation
        selectedSize={this.state.sizeSelected}
        recommendations={this.props.recommendations}
        recommendedSizeAvail={this.recommendedSizeAvail()}
        product={this.props.product}
      />
    );
  }

  handleNotifyMeOpen = e => {
    e.preventDefault();
    if (this.props.gridProductDrawer) {
      this.props.dispatch(closeGridProductDrawer());
    }
    this.props.dispatch(displayModal(MODAL_NAMES.NOTIFY_ME));
  };

  renderActiveMemberState() {
    return (
      <section
        data-test-id="membership-form-fields"
        className={`membership-form membership-form-fields ${
          this.props.flagsAndExperiments?.[flagsAndExperimentNames.RSV_1494_ATB_TABS] ? "!mt-0" : ""
        }`}>
        <div className="membership-form membership-form-fields__active-member">
          {this.isSizeAlreadyNotified() && <NotifyMeBanner />}
          {this.renderSizeSelector()}
          <UrgencySignalWrapper selectedSize={this.state.sizeSelected || this.skuIdSelected} />
          {this.renderFitRecommendation()}
          <MembershipFormFieldsBillingStatus
            membershipState={this.props.membershipState}
            isFuturePausedWithoutItemsWithinThreeDays={this.props.isFuturePausedWithoutItemsWithinThreeDays}
            isInPaymentRetry={this.props.isInPaymentRetry}
            isInSkipMode={this.props.isInSkipMode}
            hasFutureCancelDate={this.props.hasFutureCancelDate}
            membershipBag={this.props.membershipBag}
            onOpenRetryModal={this.props.onOpenRetryModal}
            onOpenPausedModal={this.props.onOpenPausedModal}
            onCancelFuturePausedModal={this.props.onCancelFuturePausedModal}
            onOpenAddShipmentModal={this.props.onOpenAddShipmentModal}
            isItemAvailable={this.isPDPItemAvailable()}
            product={this.props.product}
            productIsEligibleForUser={ProductAvailability.checkProductIsEligibleForUser(
              this.props.product,
              this.props.membershipState
            )}
          />
          {this.renderAddPurchaseToBagError()}
          {this.renderRadioButtonProps()}
        </div>
      </section>
    );
  }

  renderNonActiveMemberState() {
    const { handleWayfindCtaClick, gridProductDrawer, product } = this.props;
    const { sizeSelected } = this.state;

    return (
      <MembershipItemDummyATBContainer
        handleWayfindCtaClick={handleWayfindCtaClick}
        isGridProductDrawer={Boolean(gridProductDrawer)}
        product={product}
        renderSizeSelector={this.renderSizeSelector}
        sizeSelected={sizeSelected}
        skuIdSelected={this.skuIdSelected}
      />
    );
  }

  render() {
    const { children, membershipState } = this.props;

    const isActiveMember = isActiveMembership(membershipState);
    return (
      <>
        {isActiveMember ? this.renderActiveMemberState() : this.renderNonActiveMemberState()}
        {children}
      </>
    );
  }
}

export { MembershipFormFields as BaseMembershipFormFields };

export const mapStateToProps = (
  {
    addresses,
    ceBagCount,
    notifyMeProducts,
    favorites,
    flagsAndExperiments = {},
    gridProductDrawer,
    initialUrl,
    product,
    publicEnv,
    smBag,
    userData,
  },
  ownProps
) => ({
  // addresses are fetched independently when the page is served from Ruby. With Next, we side load them with userData.
  addresses: addresses || userData.userProfile?.addresses,
  ceBagCount,
  notifyMeProducts,
  favorites,
  gridProductDrawer,
  isSMBagEnabled: flagsAndExperiments[flagsAndExperimentNames.DRE_SF_DR_946_SIMPLIFY_MEMBERSHIP_BAG_ENABLED],
  isUrgencySignallingEnabled: flagsAndExperiments?.[flagsAndExperimentNames.RSV_1421_URGENCY_SIGNAL],
  product: product || ownProps.product, // On PDP, we read product from Redux state. For product drawer, it is passed as a prop.
  sailthruConfig: {
    customerId: publicEnv?.sailthruCustomerId,
    url: initialUrl,
  },
  smBag,
});

export const MembershipFormFieldsComponent = withMembershipStateInterface(MembershipFormFields);

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    dispatch,
    fetchSkuAvailabilities: () =>
      dispatch(
        reservationFormActions.getSizeAvailability(ownProps.product.id, {
          isBuyNow: ownProps.isBuyNow,
          filters: ownProps.workingFilters,
        })
      ),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withFeatureFlags(Flags.EARLY_ACCESS_PDP, Flags.KEEP_IT_FOREVER_RETURNS, Flags.UNLIMITED_ALWAYS_ON_ADD_ONS),
  withOnLoadFlagsAndExperiments(
    flagsAndExperimentNames.DRE_SF_DR_946_SIMPLIFY_MEMBERSHIP_BAG_ENABLED,
    flagsAndExperimentNames.RSV_1494_ATB_TABS
  ),
  withRecommendations()
)(MembershipFormFieldsComponent);
